import React, { createContext, useContext, useState, useEffect } from "react";

const AudioStreamContext = createContext();

export function useAudioStream() {
  return useContext(AudioStreamContext);
}

export function AudioStreamProvider({ user, debate, children }) {
  const [audioStream, setAudioStream] = useState(null);

  const shouldAccessMic = React.useMemo(() => {
    if (!user || !debate) return false;

    const teams =
      debate.tournament_motions?.flatMap((motion) => motion.teams) || [];
    const isParticipant = teams.some((team) =>
      team.members.some((member) => member?._id === user._id)
    );

    return isParticipant || user.isCoach || user.isAdmin;
  }, [user, debate]);

  useEffect(() => {
    const getAudioStream = async () => {
      
      console.log("DEBUG:TEST-shouldAccessMic", shouldAccessMic);

      if (!shouldAccessMic) return;

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        setAudioStream(stream);
      } catch (error) {
        console.error("Error accessing microphone:", error);
      }
    };

    getAudioStream();
  }, [shouldAccessMic]);

  return (
    <AudioStreamContext.Provider value={audioStream}>
      {children}
    </AudioStreamContext.Provider>
  );
}
